import React, { useMemo, useState } from "react";
import './Input.scss';
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs";
import { IElementType } from "./types";

interface IInputCharactersCounterProps {
    label?: string;
    element: IElementType;
    group?: string | null;
    value: boolean;
    type?: string;
    disabled?: boolean;
    // readOnly greys out and blocks interaction while PRESERVING the checked state
    // (unlike `disabled`, which forces the box to render unchecked).
    readOnly?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFunction: (args: any) => any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    saveFunction: (element?: IElementType, group?: string | null) => any;
}

export const KendoCheckbox = ({ label, element, group, value, disabled, readOnly, setFunction, saveFunction }: IInputCharactersCounterProps) => {
    const [changed, setChanged] = useState<boolean>(false);

    const handleChange = (e: CheckboxChangeEvent) => {
        setFunction({ group, element, value: e.value });
        setChanged(true);
    };

    useMemo(() => {

        if (changed) {
            saveFunction(element, group);
        }
        setChanged(false);
    }, [value]);

    return <Checkbox
        className={(disabled || readOnly) ? "checkBox disabled" : "checkBox"}
        labelPlacement={"before"}
        label={label}
        value={disabled ? false : value}
        disabled={readOnly}
        onChange={handleChange}
    />;
};
